import React, { useState, useEffect } from 'react';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import SettingsTab from './SettingsTab';
import PasswordTab from './PasswordTab';
import Background from '../../assets/images/fondo.jpeg';

const Profile = () => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('SETTINGS');
    const [name, setName] = useState('');
    const [last_name, setLastName] = useState('');
    const [rol, setRol] = useState('');
    const [avatar, setAvatar] = useState('');
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('dataUser'));
        setName(user.name);
        setLastName(user.last_name);
        setRol(user.rol.name);
        setAvatar(user.avatar);
    }, []);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleFileChange = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/users/');
        await axios.post(ENDPOINT + 'upload-avatar-user', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setTimeout(() => {
                const avatar_response = response.data.data.pathFile;
                const user = JSON.parse(localStorage.getItem('dataUser'));
                const user_id = user.user_id;
                axios.put(ENDPOINT + "update-photo-user/" + user_id, { avatar: avatar_response })
                    .then((responsedata) => {
                        setLoading(false);
                        localStorage.setItem('dataUser', JSON.stringify(responsedata.data.data));
                        window.location.reload();
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + responsedata.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
            }, 300);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Usuarios" />
            </div>

            <div className="container-fluid">
                <div className="row profile">
                    <div className="col-md-4">
                        <div className="card card-user">
                            <div className="card-header p-0">
                                <div className="profile-cover" style={{ 
                                    height: '150px', 
                                    background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${Background})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    position: 'relative'
                                }}>
                                    <div className="profile-avatar-wrapper" style={{
                                        position: 'absolute',
                                        left: '50%',
                                        bottom: '-50px',
                                        transform: 'translateX(-50%)'
                                    }}>
                                        <div className="profile-avatar-container" style={{
                                            width: '100px',
                                            height: '100px',
                                            borderRadius: '50%',
                                            border: '4px solid #fff',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            position: 'relative'
                                        }}>
                                            <img 
                                                src={URLZFILES + avatar} 
                                                alt="Avatar"
                                                style={{ 
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div className="avatar-overlay" style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: 'rgba(0,0,0,0.5)',
                                                opacity: 0,
                                                transition: 'opacity 0.3s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}>
                                                <i className="fas fa-camera text-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="card-body pt-5 mt-3">
                                <div className="text-center mb-4">
                                    <h4 className="mb-1 font-weight-bold">{name} {last_name}</h4>
                                    <span className="badge btn-primary px-3 py-2 rounded-pill">
                                        <i className="fas fa-user-tag me-1"></i> {rol}
                                    </span>
                                </div>

                                <div className="profile-info-section">
                                    <div className="photo-upload-info p-3 mb-3" style={{
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                        border: '1px dashed #dee2e6'
                                    }}>
                                        <h6 className="mb-3">
                                            <i className="fas fa-info-circle me-2"></i>
                                            Requisitos de la foto
                                        </h6>
                                        <div className="requirements-grid" style={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '10px'
                                        }}>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Formato: JPG, PNG</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Máx: 2MB</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>200x200 px</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Fondo claro</small>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="upload-section">
                                        <label 
                                            htmlFor="file-upload" 
                                            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                                            style={{
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className="fas fa-cloud-upload-alt"></i>
                                            Cambiar Foto de Perfil
                                        </label>
                                        <input 
                                            id="file-upload" 
                                            type="file" 
                                            onChange={handleFileChange}
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-8">  {/* Changed back from col-md-9 to col-md-8 */}
                        <div className="card">
                            <div className="card-header p-2">
                                <ul className="nav nav-tabs nav-justified">
                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className={`nav-link w-100 ${activeTab === 'SETTINGS' ? 'active' : ''}`}
                                            onClick={() => toggle('SETTINGS')}
                                        >
                                            <i className="fas fa-user-edit me-2"></i>
                                            Datos Personales
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className={`nav-link w-100 ${activeTab === 'ACTIVITY' ? 'active' : ''}`}
                                            onClick={() => toggle('ACTIVITY')}
                                        >
                                            <i className="fas fa-key me-2"></i>
                                            Cambiar Contraseña
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-body">
                                <div className="tab-content">
                                    <SettingsTab isActive={activeTab === 'SETTINGS'} />
                                    <PasswordTab isActive={activeTab === 'ACTIVITY'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile;